import { render, staticRenderFns } from "./AboutUsPartners.vue?vue&type=template&id=0e263edc"
import script from "./AboutUsPartners.vue?vue&type=script&lang=js"
export * from "./AboutUsPartners.vue?vue&type=script&lang=js"
import style0 from "./AboutUsPartners.vue?vue&type=style&index=0&id=0e263edc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports